// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"2bbee5d0","261":"c3c43e8a","262":"94c98ab8","555":"31433cfa","818":"5e66d712"}[chunkId] + ".chunk.js";
};